import React, { useEffect, useState } from "react";
import "./Modal.scss";
import ShowModal from "./ShowModal";
import { useLocation } from "react-router-dom";

const Modal = () => {
  // const [showModal, setShowModal] = useState(true); this is for all. when visitor's first time in website the modal open for all. that's why using true

  // for only not showing money receipt
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isMoneyReceiptPage = location.pathname.startsWith("/MR/");
    const isModalShown = sessionStorage.getItem("modal_shown");

    if (!isMoneyReceiptPage && !isModalShown) {
      // show modal on all routes except /MR/:id
      setShowModal(true);
      sessionStorage.setItem("modal_shown", "true");
    }

    // When user leaves or reloads, clear session value:
    const handleBeforeUnload = () => {
      sessionStorage.removeItem("modal_shown");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
    // !When user leaves or reloads, clear session value:
  }, [location]);

  // !for only not showing money receipt

  const closeModal = () => {
    setShowModal(false);
  };

  // const openModal = () => {
  //   setShowModal(true);
  // };
  return (
    <>
      {/* before code for all pages*/}
      {/* <div className="my_modal">
        <div className="container">
          {showModal && <ShowModal closeModal={closeModal} />}
        </div>
      </div> */}
      {/* !before code for all pages*/}

      {/* for money receipt code  */}
      {showModal && (
        <div className="my_modal">
          <div className="container">
            <ShowModal closeModal={closeModal} />
          </div>
        </div>
      )}
      {/* !for money receipt code  */}
    </>
  );
};

export default Modal;
